/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoRollRandomGemSocketsLogListRequest model module.
 * @module model/LogControllerDtoRollRandomGemSocketsLogListRequest
 * @version 1.0
 */
class LogControllerDtoRollRandomGemSocketsLogListRequest {
    /**
     * Constructs a new <code>LogControllerDtoRollRandomGemSocketsLogListRequest</code>.
     * @alias module:model/LogControllerDtoRollRandomGemSocketsLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        LogControllerDtoRollRandomGemSocketsLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>LogControllerDtoRollRandomGemSocketsLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoRollRandomGemSocketsLogListRequest} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoRollRandomGemSocketsLogListRequest} The populated <code>LogControllerDtoRollRandomGemSocketsLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoRollRandomGemSocketsLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('account')) {
                obj['account'] = ApiClient.convertToType(data['account'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoRollRandomGemSocketsLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoRollRandomGemSocketsLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of LogControllerDtoRollRandomGemSocketsLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['account'] && !(typeof data['account'] === 'string' || data['account'] instanceof String)) {
            throw new Error("Expected the field `account` to be a primitive type in the JSON string but got " + data['account']);
        }

        return true;
    }


}

LogControllerDtoRollRandomGemSocketsLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {String} account
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['account'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['nftUid'] = undefined;

/**
 * @member {Number} walletTransactionNo
 */
LogControllerDtoRollRandomGemSocketsLogListRequest.prototype['walletTransactionNo'] = undefined;






export default LogControllerDtoRollRandomGemSocketsLogListRequest;

